"use strict";
/**
 * Created by SH 16/03/2019
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Presentation = exports.PresentationState = void 0;
const PresentationView_1 = require("./PresentationView");
const StateHandler_1 = require("../../utils/StateHandler");
class PresentationState extends StateHandler_1.StateHandler {
    constructor(state = PresentationState.INACTIVE) { super(state); }
    get isEndState() {
        return this.equal(PresentationState.END);
    }
    get isInactive() {
        return this.equal(PresentationState.INACTIVE);
    }
}
PresentationState.INACTIVE = 0; // INACTIVE
PresentationState.ACTIVATED = 1; // ACTIVATED
PresentationState.END = 2; // END
exports.PresentationState = PresentationState;
class Presentation extends PresentationView_1.PresentationView {
    /**
     * config: Defines what name this presentation have for debug, and a layer option if this presentation should act as an PIXI.Container.
     *
     * customConfig: If there is any need to have some custom data for your own usage.
     *
     * @param config IPresentationConfig.
     * @param customConfig Any.
     * @returns {IPresentationConfig | undefined}.
    */
    constructor(config, customConfig) {
        super();
        this._customConfig = customConfig;
        this._config = config ? config : undefined;
    }
    /**
     * Presentation Config.
     *
     * @param data "ParsedGameData"
     * @returns {IPresentationConfig | undefined}.
    */
    get presentationConfig() { return this._config; }
    /**
     * Does NOT include TimeLine(!).
     *
     * Use this function to PreDetermine if the current presentation should get any new "ParsedGameData" and therefor be activated.
     *
     * @param data "ParsedGameData"
     * @returns {boolean} True: Triggers Function setParsedGamedData(data:any) and sets PresentationState to ACTIVATED.
    */
    checkForActivation(data) { return true; }
}
exports.Presentation = Presentation;
//# sourceMappingURL=Presentation.js.map